// import superagent from 'superagent'
import config from '../config'
import 'whatwg-fetch'

const methods = ['get', 'post', 'put', 'patch', 'del']

function formatUrl(path) {
  const adjustedPath = path[0] !== '/' ? '/' + path : path
  return config.apiHost + ':' + config.apiPort + '/api/v1' + adjustedPath
}
function serialize(obj) {
  const str = []
  Object.keys(obj).forEach((p, index) => {
    if (obj.hasOwnProperty(p)) {
      if( Array.isArray(obj[p]) ){
        obj[p].forEach( (value)=> str.push(encodeURIComponent(p) + '=' + value ))
      } else {
        str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
      }
    }
  })
  return str.join('&')
}
export default class ApiClient {
  constructor(fetchCall) {
    methods.forEach((method) =>
      this[method] = (path, { params, data } = {}) => {
        path = params ? path + '?' + serialize(params) : path
        return (fetchCall || fetch)(formatUrl(path),{
          method: method,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: data ? JSON.stringify(data) : undefined
        }).then((response)=>{
          const contentType = response.headers.get('content-type')
          if (contentType && contentType.indexOf('application/json') !== -1) {
            return response.json()
          } else {
            throw new Error('JSON not found')
          }
        })
      }
    )
  }
  empty() {}
}
